import React, { useState, useEffect } from "react";
import { Spinner, Form, Button, Container, Row, Col, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Login.scss";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { config } from "../../App";
import SuccessModal from "../../utilities/SuccessModal";


const ForgotPassword2 = () => {
  const [dob, setDob] = useState(null);
  const [employeeId, setEmployeeId] = useState("");
  const [otp, setOtp] = useState("");

  const [employeeIdError, setEmployeeIdError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [apiError, setApiError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [showOtpInput, setShowOtpInput] = useState(false);
  const [passwordResetDone, setPasswordResetDone] = useState(false);

  const [resendEnabled, setResendEnabled] = useState(false);
  const [timer, setTimer] = useState(180);
  const [loading, setLoading] = useState(false);

  const [successModal, setSuccessModal] = useState(false);
  const [isSignin, setIsSignin] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    } else {
      setResendEnabled(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const validateEmployeeId = (value) => {
    if (!value || !value.trim()) {
      return "Employee ID or Email is required.";
    }

    const trimmed = value.trim();

    const employeeIdRegex = /^(?:(?:EMP|ECN|SG)?\d{4,10}|[a-zA-Z0-9._%+-]{1,}[@][a-zA-Z0-9.-]{2,}\.[a-zA-Z]{2,})$/i;

    // if (!employeeIdRegex.test(trimmed)) {
    //   if (trimmed.includes("@")) {
    //     return "Please enter a valid email address (e.g. name@company.com)";
    //   }
    //   return "Invalid Employee ID format. Allowed examples: 567890, EMP1234, ECN0001, SG9999";
    // }

    return "";
  };

  const formatDob = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const handleEmployeeIdChange = (e) => {
    const val = e.target.value;
    setEmployeeId(val);
    setEmployeeIdError(validateEmployeeId(val));
    setApiError("");
  };

  const handleOtpChange = (e) => {
    const val = e.target.value;
    if (val.length <= 6) {
      setOtp(val);
      setOtpError(
        !val.trim()
          ? "Please enter OTP."
          : !/^\d{6}$/.test(val)
            ? "OTP must be exactly 6 digits."
            : ""
      );
    }
  };

  const handleGenerateOTP = async () => {
    const err = validateEmployeeId(employeeId);
    setEmployeeIdError(err);

    if (err || !dob) {
      if (!dob) setApiError("Please select Date of Birth.");
      return;
    }

    setLoading(true);
    setApiError("");

    try {
      const res = await axios.post(`${config.endpoint}/auth/GenerateOTP`, {
        username: employeeId,
        dob: formatDob(dob),
      });

      console.log("res", res.data)

      if (res.data.status === true) {
        setShowOtpInput(true);
        setResendEnabled(false);
        setTimer(180);
        setApiError("");
      } else {
        //setApiError("Invalid Date Format DOB/DOJ field.");
        setApiError(res.data.ResponseMessage)
      }
    } catch (err) {
      setApiError("Something went wrong. Please try again.");
      console.error("Generate OTP error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleResendOTP = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`${config.endpoint}/auth/GenerateOTP`, {
        username: employeeId,
        dob: formatDob(dob),
      });

      if (res.data.status === true) {
        setTimer(180);
        setResendEnabled(false);
        setOtp("");
        setOtpError("");
        setApiError("");
      } else {
        //setApiError("Invalid Date Format DOB/DOJ field.");
        setApiError(res.data.ResponseMessage)
      }
    } catch (err) {
      setApiError("Failed to resend OTP");
      console.error("Resend OTP error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    if (!/^\d{6}$/.test(otp)) {
      setOtpError("OTP must be exactly 6 digits.");
      return;
    }

    setLoading(true);
    setApiError("");

    try {
      const res = await axios.post(`${config.endpoint}/auth/ValidateOTP`, {
        username: employeeId,
        otp,
      });

      if (res.data.status === true) {
        setPasswordResetDone(true);
        setSuccessMessage(res.data.ResponseMessage);
        setSuccessModal(true);
        //navigate(`/${config.baseUrl}/login`)
      } else {
        console.log(typeof res.data.ResponseMessage)
        setApiError(res.data.ResponseMessage);
      }
    } catch (err) {
      setApiError("Error verifying OTP. Please try again.");
      console.error("Verify OTP error:", err);
    } finally {
      setLoading(false);
    }
  };

  const closeSuccessModal = () => {
    setSuccessModal(false);
    navigate(`/login`)
  }

  const formatTimer = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec < 10 ? "0" : ""}${sec}`;
  };

  return (
    <>
      <section className="login-wrapper loginSecondDesign d-flex align-items-center">

        <Container>
          <div className="login-card shadow-lg">

            <Row className="">
              <Col md={12}>

                <div className={`card ${isSignin ? "signin-mode" : ""}`}>


                  <div className="overlay-panel">
                    <div class="diamond d1"></div>
                    <div class="diamond d2"></div>
                    <div class="diamond d3"></div>
                    <div class="circle c1"></div>
                    <div class="circle c2"></div>
                    <div class="tri t1"></div>
                    <div className="DesignOne"></div>
                    <div className="DesignTwo"></div>
                    {/* <div className="logo">Diprella</div> */}
                    {/* <div className="logo">
                      <img src="./images/logo.svg" alt="spicejet" className="img-fluid" />
                    </div> */}

                    {!isSignin ? (
                      <div className="overlay-content active">
                        <h2>Hello, Employee!</h2>
                        <p class="overlay-sub">Don't worry! Enter your Employee ID and Date of Birth to reset your password securely.</p>
                        {/* <button
                          type="button"
                          onClick={() => setIsSignin(true)}
                        >
                          Register
                        </button> */}
                      </div>
                    ) : (
                      <div className="overlay-content ps-4 active">
                        {/* <h2>Welcome Back!</h2>
                        <p class="overlay-sub">Access your Employee Self Service portal to manage SOD, ELT, payslips, Form 16, and other employee services.</p>
                        <button
                          type="button"
                          onClick={() => setIsSignin(false)}
                        >
                          Login
                        </button> */}
                      </div>
                    )}
                  </div>

                  <div className="forms-container">
                    <div className="form-panel signup-form">
                      <div className="logo mt-0">
                        <img src="/images/logo.svg" alt="spicejet" className="img-fluid" />
                      </div>

                      <h1 className="mt-lg-4 mt-md-3 pt-3 mb-0 font-xxxl">
                        Forgot Your<span className="primary-text bold"> Password</span></h1>

                      {apiError && !showOtpInput && (
                        <p className="text-danger mt-2 font-sm">{apiError}</p>
                      )}

                      <Form className="mt-4">
                        <Form.Group className="mb-3 pb-4 mb-0 position-relative">
                          <Form.Label className="font-xl">
                            Employee ID <sup className="primary-text font-md">*</sup>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            className="p-3 font-md dark-grey-text"
                            placeholder="Enter Employee ID"
                            value={employeeId}
                            onChange={handleEmployeeIdChange}
                          // isInvalid={!!employeeIdError}
                          />
                          {employeeIdError && (
                            <Form.Control.Feedback type="invalid">
                              {employeeIdError}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>

                        <Form.Group className="my-3 pb-4 mb-0 position-relative">
                          <Form.Label className="font-xl d-block">
                            Date Of Birth <sup className="primary-text font-md">*</sup>
                          </Form.Label>
                          <DatePicker
                            selected={dob}
                            onChange={(date) => {
                              setDob(date);
                              setApiError("");
                            }}
                            className={`form-control w-100 p-3 font-md dark-grey-text ${apiError && !dob ? "is-invalid" : ""
                              }`}
                            placeholderText="Select Date of Birth"
                            dateFormat="dd/MM/yyyy"
                            maxDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            yearDropdownItemNumber={15}
                            scrollableYearDropdown
                          />
                        </Form.Group>

                        {showOtpInput && (
                          <>
                            <Form.Group className="my-3">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <Form.Label className="font-xl mb-0">
                                  OTP <sup className="primary-text font-md">*</sup>
                                </Form.Label>
                                <button
                                  type="button"
                                  className="font-xs link-dark px-0 bg-transparent border-0"
                                  onClick={handleResendOTP}
                                  disabled={!resendEnabled || loading}
                                >
                                  {resendEnabled ? "Resend OTP" : `Resend OTP in ${formatTimer(timer)}`}
                                </button>
                              </div>
                              <Form.Control
                                type="text"
                                className="p-3 font-md dark-grey-text"
                                placeholder="Enter 6-digit OTP"
                                value={otp}
                                onChange={handleOtpChange}
                                maxLength={6}
                              //isInvalid={!!otpError}
                              />
                              <div className="d-flex justify-content-between align-items-center mt-1" style={{ minHeight: "1.2rem" }}>
                                <div className="font-sm regular text-danger">
                                  {otpError || (apiError && showOtpInput ? apiError : "")}
                                </div>
                                <p className="mb-0 font-xs success-text text-end">
                                  OTP sent on your email
                                </p>
                              </div>
                            </Form.Group>

                            <div className="d-flex justify-content-between align-items-center mt-2">

                              {/* <button
                                type="button"
                                className="font-xs link-dark px-0 bg-transparent border-0 mb-3"
                                onClick={handleResendOTP}
                                disabled={!resendEnabled || loading}
                              >
                                Resend OTP {!resendEnabled && `in ${formatTimer(timer)}`}
                              </button>
                              <p className="font-xs success-text">OTP sent on your email</p> */}
                            </div>
                          </>
                        )}

                        <div className="mt-0">
                          {!showOtpInput ? (
                            <Button
                              className="btn-primary submit-btn font-md btn btn-animation w-100 text-uppercase"
                              onClick={handleGenerateOTP}
                              disabled={loading || !!employeeIdError || !employeeId.trim() || !dob}
                            >
                              {loading ? (
                                <Spinner as="span" animation="border" size="sm" role="status" />
                              ) : (
                                "Send OTP"
                              )}
                            </Button>
                          ) : (
                            <Button
                              className="btn-primary submit-btn font-md btn btn-animation w-100 text-uppercase"
                              onClick={handleVerifyOTP}
                              disabled={loading || !!otpError || otp.length !== 6}
                            >
                              {loading ? (
                                <Spinner as="span" animation="border" size="sm" role="status" />
                              ) : (
                                "Verify OTP"
                              )}
                            </Button>
                          )}
                        </div>

                        <div className="d-flex mt-4 justify-content-center">
                          <Link
                            to={`/login`}
                            className="font-sm primary-text text-decoration-none"
                          >
                            Back to login
                          </Link>
                        </div>
                      </Form>

                      
                    </div>

                    <div className="form-panel signin-form">
                      
                      
                    </div>

                  </div>

                </div>

              </Col>
            </Row>

          </div>
        </Container>
        <SuccessModal
          isOpen={successModal}
          onClose={closeSuccessModal}
          message={successMessage}
        />
      </section>
    </>
  );
};

export default ForgotPassword2;